// extracted by mini-css-extract-plugin
module.exports = {"Tabs_box":"index_Tabs_box__1ULkQ"};